exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-mor-sec[data-v-42760364]{position:relative}.loader-overlay[data-v-42760364]{padding:30px;position:relative}.loader[data-v-42760364]{border:16px solid #f3f3f3;border-radius:50%;border-top:16px solid #e52e28;width:120px;height:120px;-webkit-animation:spin-data-v-42760364 2s linear infinite;animation:spin-data-v-42760364 2s linear infinite}@-webkit-keyframes spin-data-v-42760364{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes spin-data-v-42760364{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42760364","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/searchLoadMoreComponent.vue
// module id = 67
// module chunks = 1